import { render, staticRenderFns } from "./PenilaianEvaluasi.vue?vue&type=template&id=86568f6c"
import script from "./PenilaianEvaluasi.vue?vue&type=script&lang=js"
export * from "./PenilaianEvaluasi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports